import React from 'react';
import { Upload } from 'antd';
import StorageUtils from '../../../utils/storage-session-utils';
import notifyUtitls from '../../../utils/notify-utils';
import { MAX_IMAGE_UPLOAD_BYTES } from '../../../constants/app-constants';
import useUploadStatus from '../use-upload-status';

/** NMU-520: "5 MB", not "5242880 bytes" — the message is for an editor. */
const formatSize = (bytes) => {
    const mb = bytes / (1024 * 1024);
    return `${Number.isInteger(mb) ? mb : mb.toFixed(1)} MB`;
};

const UploadImage = ({ children, limitHeight, limitWidth, limitSize = MAX_IMAGE_UPLOAD_BYTES, onChange, ...props }) => {
    const { fileList = [] } = props;
    const uploadTempEndpoint = process.env.REACT_APP_API_ENDPOINT + "/upload/temp";
    const headers = {
        Authorization: 'Bearer ' + StorageUtils.getToken()
    }
    /*
      NMU-524: progress, success and failure all come from the shared hook, so
      this behaves exactly like the document uploader. It used to report only
      failures, and only here.
    */
    const withStatus = useUploadStatus(formatSize(limitSize));

    const beforeUpload = (file) => {

        const duplicate = fileList.find(({ name }) => name === file.name);
        if (duplicate) {
            notifyUtitls.warning('แจ้งเตือน', 'ไฟล์อัพโหลดมีชื่อซ้ำ!');
            return Upload.LIST_IGNORE;
        }

        if (!file.type.includes('image/')) {
            notifyUtitls.error({ title: 'แจ้งเตือน', message: 'ประเภทไฟล์รูปภาพไม่ถูกต้อง' });
            return Upload.LIST_IGNORE;
        }

        // NMU-520: `limitSize` now defaults rather than being opt-in. Every form
        // that omitted it sent the file and let nginx answer 413, which reads to
        // an editor as nothing happening at all.
        if (limitSize && file.size > limitSize) {
            notifyUtitls.error({
                title: 'แจ้งเตือน',
                message: `ไม่สามารถอัปโหลดรูปภาพได้ กรุณาเลือกไฟล์ที่มีขนาดไม่เกิน ${formatSize(limitSize)}`,
            });
            return Upload.LIST_IGNORE;
        }

        if (!limitHeight && !limitWidth) {
            return true;
        }

        //read file
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                const img = document.createElement('img');
                img.src = reader.result;
                img.onload = () => {
                    const msgs = [];
                    if (limitWidth && this.width > limitWidth) {
                        msgs.push("ความกว้างของรูปภาพต้องไม่เกิน " + limitWidth + " px.");
                    }
                    if (limitHeight && this.height > limitHeight) {
                        msgs.push("ความสูงของรูปภาพต้องไม่เกิน " + limitHeight + " px.");
                    }
                    if (msgs.length > 0) {
                        notifyUtitls.error({ title: 'แจ้งเตือน', message: msgs.join(" และ") });
                        reject(Upload.LIST_IGNORE);
                    } else {
                        resolve(true);
                    }
                }
            }

        });
    }

    return (
        <Upload
            {...props}
            action={uploadTempEndpoint}
            method="POST"
            headers={headers}
            beforeUpload={beforeUpload}
            onChange={withStatus(onChange)}
        >
            {children}
        </Upload>
    )

}

export default UploadImage;
